import React, { type FC } from 'react';
import { dispatchDataLayerEntry } from '../../helpers/dataLayerHelpers/productDataLayerHelper';
import { ProductList } from '../homepage/product-list/ProductList';
import { ListProps } from '../homepage/product-list/types';

interface Props {
  products?: ListProps[];
}

export const VerticalFeaturedBanner: FC<Props> = ({ products }) => {
  if (!products) return null;

  const handleOnImpression = () => {
    dispatchDataLayerEntry(
      'vertical banner impression',
      'display',
      {
        experimentId: 'exp1105_vertical_banner_product_listing_page',
      },
    );
  };

  const handleOnClick = (id: number) => {
    dispatchDataLayerEntry(
      'vertical banner click on product',
      'click',
      {
        experimentId: 'exp1105_vertical_banner_product_listing_page',
        contentfulId: products[id - 1].id,
      },
    );
  };

  return (
    <div className="pd-relative pd-grid pd-gap-6 lg:pd-grid-cols-3">
      <div className="lg:pd-order-2 lg:pd-col-span-2">
        <ProductList
          list={products}
          clickHandler={handleOnClick}
          impressionHandler={handleOnImpression}
          cardVariant="square"
          maxItems={6}
          columns={3}
          twoColumnBreakpoint="max-lg"
        />
      </div>
    </div>
  );
};
